import React from 'react';
import ButtonJumpCalendar from "../../../components/Basic/ButtonJumpCalendar";
import { CALENDAR_ID } from "../constants";
import stylesCalendar from '../style.module.scss';
import ShowAllPlans from './ShowAllPlans';
import styles from './style.module.scss';
import VesselFilter from './VesselFilter';

interface IProps { }

const Header: React.FC<IProps> = () => {
    return <div className={styles.title}>
        <div className={styles['title-left']}>
            <span className="text-[20px] mr-3">
                Operation overview
            </span>
            <ButtonJumpCalendar
                calenderId={CALENDAR_ID}
                getHeightWeek={() => {
                    const { offsetHeight }: any = document.getElementsByClassName(stylesCalendar.week)[0] || { offsetHeight: 0 }
                    return offsetHeight;
                }}
            />
            <ShowAllPlans />
            <VesselFilter />
        </div>
    </div>;
};

export default Header;
